<template>
  <div id="sub-header">
    <div
      class="sub-text text-right"
      data-bs-toggle="offcanvas"
      data-bs-target="#sidebar"
    >
      <span 
        v-if="userData"
        class="identity-text"
      >
        Hello, {{ userData.firstName }} {{ userData.lastName }}</span
      >
      <font-awesome-icon class="mx-1 ml-2 mt-1" icon="fa-ellipsis-v fa-sm" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      userData: "general/getUserData",
    }),
  }
};
</script>

<style lang="scss" scoped>
#sub-header {
  margin-top: 0.5em;

  .sub-text {
    margin-top: 0.35em;

    &:hover {
      cursor: pointer;
    }
  }

  .profile-avatar {
    margin-top: -0.3em;
  }

  .dropdown-icon {
    font-size: 13px;
  }
}
</style>
